$(document).on("turbolinks:load", function () {
  if ($(".js-bar-rating").length) initializeBarRating(".js-bar-rating")
})

export function initializeBarRating(elementSelector) {
  $(elementSelector).barrating({
    deselectable: false,
    theme: "fontawesome-stars",
  })
}
